{#if loc.endsWith('pruefung') || loc.endsWith('beantwortet')}
<div class="demo-control notification is-warning">
    <button class="button" on:click="{resetExam}">Prüfung zurücksetzen</button><br>
    Die Antworten werden gelöscht und die Prüfung kann erneut gestartet werden.<br>
    Die grünen Hilfestellungen zur Beantwortung der Multiple-Choice-Fragen werden nur in Demo angezeigt.
</div>
{/if}

<script>
import { location, push } from "svelte-spa-router";
import { demoSvc, progressSvc } from "./services";
import { currentChapter } from "./stores";

let ch, loc;
currentChapter.subscribe((data) => (ch = data));
location.subscribe((data) => (loc = data));

const resetExam = () => {
  if (demoSvc.isDemoInstance) {
    progressSvc.setUserProgress({
      closedPopups: {
        page_login: true,
        page_manager: true,
        page_intro: true,
        page_home: true,
        page_platzreife: true,
      },
      chapters: {
        abschlag: {
          status: "finished",
          videoPlayed: true,
          rulesRead: { "0": true, "1": true, "2": true },
        },
      },
    });
    setTimeout(() => {
      window.location.href =
        window.location.origin + "/#/platzreife/" + ch.slug + "/pruefung";
      window.location.reload();
    }, 100);
  }
};
</script>

<style type="text/scss">
.demo-control {
  display: inline-block;
  padding: 5px 10px 10px;
}
</style>
